@if (InPatientOlderAge?.count! > 0) {
  <div
    id="divChart"
    class="chart-container"
    >
    <canvas id="inPatientOlderAge"> </canvas>
  </div>
}
